module.exports = {"service_contents":[{"type":"service_headline"},{"type":"service_photos"},{"type":"service_fleets","content":"service_content_fleets"},{"type":"service_fleets","content":"service_content_additional"},{"type":"service_fleets","content":"service_content_hourly"}],"hero":"background-image: url(/img/services_banner_bg.jpg)"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/en_hk/setting/service/setting.json
// module id = 607
// module chunks = 0 1 2 3 4 5